import { Link } from '@tanstack/react-router';
import { Card, linkTextClasses } from '@evogard/ui';
import { useRetentionSummaries } from './useRetention.js';

/**
 * O painel do Kanban Cancelamento no Início: quanto há em cada etapa, somadas
 * as bases que a pessoa vê.
 */
export function RetentionPanel() {
  const { ready, loading } = useRetentionSummaries({});
  const totals = { start: 0, working: 0, h48: 0, h72: 0 };
  for (const { summary } of ready) {
    for (const c of summary.columns) {
      if (c.key === 'inicio') totals.start += c.count;
      else if (c.key === 'envio_email_72h') totals.h72 += c.count;
      else if (c.key.endsWith(':atendimento_48h')) totals.h48 += c.count;
      else if (c.key.endsWith(':em_atendimento')) totals.working += c.count;
    }
  }
  return (
    <Card title="Kanban Cancelamento">
      {loading ? (
        <p className="text-sm text-texto-suave">Carregando…</p>
      ) : (
        <dl className="grid grid-cols-2 gap-3 text-sm">
          <div>
            <dt className="text-texto-suave">Início</dt>
            <dd className="text-xl font-semibold">{totals.start}</dd>
          </div>
          <div>
            <dt className="text-texto-suave">Em atendimento</dt>
            <dd className="text-xl font-semibold">{totals.working}</dd>
          </div>
          <div>
            <dt className="text-texto-suave">48 horas</dt>
            <dd className="text-xl font-semibold">{totals.h48}</dd>
          </div>
          <div>
            <dt className="text-texto-suave">72 horas</dt>
            <dd className="text-xl font-semibold">{totals.h72}</dd>
          </div>
        </dl>
      )}
      <Link to="/retention/board" className={linkTextClasses()}>
        Abrir o quadro
      </Link>
    </Card>
  );
}
